import {
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    Checkbox,
    Typography,
    Tooltip,
    useTheme,
} from '../../../../../../base-components';
import { IActiveFilter, IFilterOption } from '../../../../../table.interfaces';
import { IOption } from '../../../../../../base-forms';

interface ISelectorMenuProps {
    filters: Array<IFilterOption>;
    activeFilters: Array<IActiveFilter>;
    activeFilterIndex: number;
    handleValueSelect: (value: IOption) => void;
}

const SelectorMenu = (props: ISelectorMenuProps) => {
    const theme = useTheme();
    const { filters, activeFilters, activeFilterIndex, handleValueSelect } =
        props;
    const activeFilter = filters.find(
        (ft) => ft.id === activeFilters[activeFilterIndex].filterId
    );

    return (
        <List>
            {activeFilter?.optionValues?.map((option) => (
                <Tooltip
                    key={option.key}
                    title={
                        option.disabled
                            ? 'This item cannot be selected'
                            : option.tooltipText || option.label
                    }
                    placement="right"
                >
                    <div>
                        <ListItem disablePadding>
                            <ListItemButton
                                onClick={() => {
                                    if (!option.disabled) {
                                        handleValueSelect(option);
                                    }
                                }}
                                selected={activeFilters[
                                    activeFilterIndex
                                ].values.some(
                                    (value) => value.value === option.value
                                )}
                                disabled={option.disabled}
                                sx={{
                                    '&.Mui-disabled': {
                                        opacity: 0.5,
                                        cursor: 'not-allowed',
                                    },
                                    height: '40px',
                                    padding: '4px 8px',
                                }}
                            >
                                <ListItemIcon sx={{ marginInlineEnd: 1 }}>
                                    <Checkbox
                                        checked={activeFilters[
                                            activeFilterIndex
                                        ].values.some(
                                            (value) =>
                                                value.value === option.value
                                        )}
                                        disabled={option.disabled}
                                        onChange={() =>
                                            handleValueSelect(option)
                                        }
                                    />
                                </ListItemIcon>
                                <Typography
                                    variant="body2"
                                    color={theme.palette.grey[600]}
                                    textOverflow="ellipsis"
                                    whiteSpace="nowrap"
                                    overflow="hidden"
                                >
                                    {option.label}
                                </Typography>
                            </ListItemButton>
                        </ListItem>
                    </div>
                </Tooltip>
            ))}
        </List>
    );
};

export default SelectorMenu;
